<div
  [id]="identifier + '-feedbacks'"
  class="invalid-feedback d-block"
  role="alert"
  *ngIf="hasFeedbackError && touched"
>
  {{ feedbackErrorMessage }}
</div>
